import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header
        fixed
        *ngIf="isAuthenticated && !url.includes('administration')"
      >
        <ngx-header></ngx-header>
      </nb-layout-header>
      <nb-sidebar
        class="menu-sidebar test"
        tag="menu-sidebar"
        responsive
        *ngIf="isAuthenticated && !url.includes('administration')"
        (stateChange)="changeSidebarState($event)"
      >
        <ng-content select="nb-menu"></ng-content>
        <ngx-change-theme
          class="change-theme-toggle-content"
        ></ngx-change-theme>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"> </ng-content>
      </nb-layout-column>

      <nb-layout-footer
        fixed
        *ngIf="isAuthenticated && !url.includes('administration')"
      >
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {
  isAuthenticated = false;
  url: string;
  constructor(private storageService: StorageService, public router: Router) {
    router.events.subscribe(async (val) => {
      if (val instanceof NavigationEnd) {
        this.url = router.url;
        this.isAuthenticated =
          this.storageService.getItem('user') !== null ? true : false;
      }
    });
  }

  changeSidebarState(event: string) {
    this.storageService.isSidebarClose = event === 'expanded' ? false : true;
  }
}
